import type { ReactNode } from "react";

type Props = {
  id?: string;
  title: ReactNode;
  lead?: ReactNode;
  align?: "left" | "center";
  tone?: "ink" | "light";
  as?: "h1" | "h2";
  size?: "lg" | "xl";
  className?: string;
};

/** Section heading with an optional lead. The heading carries its own weight. */
export function SectionHeader({
  id,
  title,
  lead,
  align = "left",
  tone = "ink",
  as: Tag = "h2",
  size = "lg",
  className = "",
}: Props) {
  const center = align === "center";
  const titleSize =
    size === "xl"
      ? "text-[clamp(2.4rem,5.2vw,4.25rem)] leading-[1.04]"
      : "text-[clamp(2rem,4vw,3.25rem)] leading-[1.08]";
  return (
    <div className={`${center ? "mx-auto text-center" : ""} max-w-3xl ${className}`}>
      <Tag
        id={id}
        data-reveal=""
        className={`font-display font-semibold tracking-[-0.02em] ${titleSize} ${tone === "light" ? "text-white" : "text-brand-primary"}`}
      >
        {title}
      </Tag>
      {lead ? (
        <p
          className={`mt-5 max-w-2xl text-lg leading-relaxed ${center ? "mx-auto" : ""} ${tone === "light" ? "text-on-navy-muted" : "text-ink-soft"}`}
        >
          {lead}
        </p>
      ) : null}
    </div>
  );
}
